import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { UserAuthorities } from '../../constants/user-authorities.const';
import { SessionState, SessionStore } from './session.store';
import { Observable } from 'rxjs';
import { User } from '../../models/user.model';
import {TopUnitModel} from '../../models/top-unit.model';
import {map} from 'rxjs/operators';

@Injectable()
export class SessionQuery extends Query<SessionState> {
  public loading$: Observable<boolean> = this.select(({ loading }) => loading);
  public user$: Observable<User> = this.select(({ user }) => user);
  public topUnit$: Observable<TopUnitModel[]> = this.user$.pipe(
    map(user => user.topUnits || []),
    map((arr: TopUnitModel[]) => {
      return arr.slice().sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    })
  );

  hasAuthority(authority: UserAuthorities): Observable<boolean> {
    return this.select(({ user }) => !!user && user.authorities.includes(authority));
  }

  getCurrentUserId(): number {
    return Number(this.getValue().user.id);
  }

  constructor(protected store: SessionStore) {
    super(store);
  }
}
